import { render } from "./RichTextEditor.vue?vue&type=template&id=358a41be"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/RichTextEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "358a41be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('358a41be', __exports__)) {
    console.log('reload')
    api.reload('358a41be', __exports__)
  }
  
  module.hot.accept("./RichTextEditor.vue?vue&type=template&id=358a41be", () => {
    console.log('re-render')
    api.rerender('358a41be', render)
  })

}


export default __exports__